import { gql } from "@apollo/client";

export const verifyPayment = gql`
query verifyAccountDetails($input: PaystackValidateAccountInput!) {
  verifyAccountDetails(input: $input)
}
`